<template>
  <h3 class="pb5">Rapport par numéro de série et dénomination (CDX_0153)</h3>
  <CritereRechercheConsignation :cacherChampTypeConsignation="true" ref="critereRechercheConsignation"
                                :entiteDefault="entiteDefault" :siteDefault="siteDefault"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from "vuex";
import CritereRechercheConsignation from "@/components/rapports/Rechercher/CritereRechercheConsignation.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";

export default {
  name: "numeroSerieDenominationConsignationRapport",
  components: {CritereRechercheConsignation, ButtonBar},

  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consignation");
    this.isRechercheDataLoading = true;

    this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
      this.entiteDefault = res.data.entite;
      this.siteDefault = res.data.site;

      this.$store.dispatch('consignation/initialisationDecisionLibelleVOsDeCriteresAction').then((res) => {
        this.assignerResultat(res)
        this.isRechercheDataLoading = false;
      });
    });
  },

  data() {
    return {
      isRechercheDataLoading: false,
      consignations: [],
      entiteDefault: null,
      siteDefault: null,
    }
  },

  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },

  methods: {
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages
      this.$refs.critereRechercheConsignation.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheConsignation.getCritereRecherche();
      criteresRapportVO.titre = "numeroSerieDenominationConsignationRapport";
      criteresRapportVO.nomRapport = "consignation.NumeroSerieDenominationConsignationGenerateurRapport_CDX_0153";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRapportVO)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  }
}
</script>

<style scoped>

</style>